import { useEffect, useState } from "react";

export function BaglantiBandi() {
  const [cevrimdisi, setCevrimdisi] = useState(() => !navigator.onLine);
  useEffect(() => {
    const acik = () => setCevrimdisi(false);
    const kapali = () => setCevrimdisi(true);
    window.addEventListener("online", acik);
    window.addEventListener("offline", kapali);
    return () => {
      window.removeEventListener("online", acik);
      window.removeEventListener("offline", kapali);
    };
  }, []);
  // F-STV-11 — bağlantı kaybı formu sökmemeli; panel yazmaları otomatik kuyruğa alınmaz.
  if (!cevrimdisi) return null;
  return (
    <p
      role="status"
      className="border-uyari-200 bg-uyari-50 text-uyari-800 sticky top-0 z-50 border-b px-4 py-3 text-sm"
    >
      İnternet bağlantınız kesildi. Açık ekranınız korunuyor; kaydetmek için bağlantınızı yeniden
      kurunuz.
    </p>
  );
}
